import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import ContainerMobile from 'components/container-mobile';
import Booking from './pages/guest/booking';
import TherapistDetail from './pages/guest/therapist/TherapistDetail';
import AboutUs from './pages/guest/about-us';
import Review from './pages/guest/review';

const Home = lazy(() => import('./pages/guest/home'));
const Therapist = lazy(() => import('./pages/guest/therapist'));
const Service = lazy(() => import('./pages/guest/service'));
const ServiceDetail = lazy(() => import('./pages/guest/service/ServiceDetail'));
const MyBooking = lazy(() => import('./pages/guest/my-booking'));
const MyBookingList = lazy(() => import('./pages/guest/my-booking/MyBookingList'));
const Login = lazy(() => import('./pages/admin/login'));
const Search = lazy(() => import('./pages/guest/search/Search'));
const BookingDetail = lazy(() => import('./pages/guest/my-booking/MyBookingDetail'));
const LoginTherapist = lazy(() => import('./pages/therapist/login'));
const Chat = lazy(() => import('./pages/general/chat'));
// const NotFound = lazy(() => import('./pages/not-found'));

function RoutingGuest() {
    return (
        <Routes>
            <Route path="/auth" element={<Login />} />
            <Route path="/auth-therapist" element={<LoginTherapist />} />

            <Route path="/" element={<ContainerMobile />}>
                <Route path="/chat/:chatId?/:bookingId?" element={<Chat />} />
                <Route index element={<Home />} />
                <Route path="therapist" element={<Therapist />} />
                <Route path="therapist-detail/:masseusesId" element={<TherapistDetail />} />
                <Route path="all-services" element={<Service />} />
                <Route path="booking-detail" element={<Booking />} />
                <Route path="booking-detail/:masseusesId" element={<Booking />} />
                <Route path="booking-detail/:masseusesId/:serviceId" element={<Booking />} />
                <Route path="service-detail/:serviceId" element={<ServiceDetail />} />
                <Route path="about-us" element={<AboutUs />} />
                <Route path="service-feedback/:bookingCode" element={<Review />} />
                <Route path="mybooking" element={<MyBooking />} />
                <Route path="mybooking.list/:phoneNumber" element={<MyBookingList />} />
                <Route path="mybooking.list/detail/:bookingCode" element={<BookingDetail />} />
                <Route path="search" element={<Search />} />
            </Route>
        </Routes>
    );
}

export default RoutingGuest;
